var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{ref:"dialog",attrs:{"ok-text":"Confirm","inputs-map":_vm.inputs,"hasFooter":true,"save-cb":_vm.changePickUpDate,"title":"Set Pick Up Date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }